import { EKitchenStove } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectKitchenStoveFilter } from 'shared/selectors/advancedFilters/kitchenStove';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const KitchenStoveContainer: FC = () => {
  const { label, value, options } = useSelector(selectKitchenStoveFilter);

  const onChange = useFilterChangeCallback();

  const handleKitchenStoveChange = useCallback(
    (newValue: EKitchenStove | null) => {
      onChange({ action: 'setKitchenStove', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleKitchenStoveChange} />
    </AdvancedFilterRow>
  );
};
